import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const actionCenter = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.75,
  associationType: 'action-center-SquareLogoMedia',
  type: 'Image178x100',
  className: 'boost-actionCenter',
  imagePreviewHeight: 160,
  logoHeight: 48,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [280, 160],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Action Center'),
    stringKey: _TL_('Action Center'),
  },
  previewSettings: {
    previewContentClassName: 'boost-actionCenter',
    showLogo: true,
    showShortHeadline: true,
    multipleDescription: true,
    showDescription: true,
    showAction: true,
    showBusinessName: false,
    showImage: false,
    showDismiss: true,
    dismissText: _TL_('Dismiss'),
  },
  styleOverrides: {
    cardParent: {
      marginTop: 'auto',
      marginBottom: 'auto',
      '& .responsive-ad-preview-content': {
        width: '280px !important',
        height: 150,
        backgroundColor: '#e8e9eb',
      },
      '& .logo-container': {
        position: 'absolute',
        top: 20,
        left: 20,
      },
      '& .short-headline': {
        position: 'absolute',
        top: 20,
        left: 80,
        width: 180,
        fontSize: 12,
        color: 'black',
        fontWeight: 'bold',
      },
      '& .description': {
        position: 'absolute',
        top: 50,
        fontSize: 12,
        left: 80,
        width: 180,
        color: 'black',
      },
      '& .action-button': {
        position: 'absolute',
        left: 20,
        top: 120,
        color: 'black',
        width: 120,
        backgroundColor: 'white',
        border: 'none',
        height: 20,
        fontSize: '10px !important',
        borderRadius: '0px !important',
      },
      '& .dismiss-button': {
        position: 'absolute',
        left: 150,
        top: 120,
        width: 120,
        color: 'black',
        backgroundColor: 'white',
        border: 'none',
        height: 20,
        borderRadius: '0px !important',
      },
    },
  },
};

export default actionCenter;
